import Long from "long";
import _m0 from "protobufjs/minimal";
export const protobufPackage = "snapchat.cdp.cof";
export interface PerceptionSignals {
    scannedCategoryIds: string[];
}
function createBasePerceptionSignals(): PerceptionSignals {
    return { scannedCategoryIds: [] };
}
export const PerceptionSignals = {
    encode(message: PerceptionSignals, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        for (const v of message.scannedCategoryIds) {
            writer.uint32(10).string(v!);
        }
        return writer;
    },
    decode(input: _m0.Reader | Uint8Array, length?: number): PerceptionSignals {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePerceptionSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.scannedCategoryIds.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial<I extends Exact<DeepPartial<PerceptionSignals>, I>>(object: I): PerceptionSignals {
        const message = createBasePerceptionSignals();
        message.scannedCategoryIds = object.scannedCategoryIds?.map((e) => e) || [];
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long as any;
    _m0.configure();
}
